import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { IconMoon, IconSun } from './layout/NavIcons';

type ThemeToggleProps = {
  className?: string;
};

export function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`rounded-lg p-2 text-muted transition-colors hover:bg-foreground/5 hover:text-foreground ${className}`}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <IconSun className="h-6 w-6" /> : <IconMoon className="h-6 w-6" />}
    </button>
  );
}
